import { WishListItemStatus } from '../../../../models/wish-list';

export const getBannerMessage = (wishListItemStatus: WishListItemStatus): string => {
    switch (wishListItemStatus) {
        case WishListItemStatus.Removed:
            return 'app.notification.articleRemoved.wishListitem';
        case WishListItemStatus.PriceByRequest:
            return 'app.notification.priceByRequest.wishListitem';
        default:
            return 'app.notification.articleRemoved.wishListitem';
    }
};
